export default __webpack_public_path__ + "static/media/s-21.fb7cc337.jpg";